import { useEffect, useState } from 'react'
import toast, { Toaster } from 'react-hot-toast'
import { Tabs } from '../../../components/tabs/Tabs'
import { translations } from '../../../configs/translations'
import { Language } from '../../../context/LanguageContext'
import { RaceTypes } from '../../../enums/RaceTypes'
import { AchievementResponse } from '../../../models/response/AchievementResponse'
import { UserProfile } from '../../../models/UserProfile'
import AccomplishmentsService from '../../../services/AccomplishmentsService'
import { formatTextWithParams } from '../../../utils/formatTextWithParams'
import { Header } from '../../main/header/Header'
import { Achievement } from './achievement/Achievement'
import './Achievements.css'

export const Achievements = () => {

    const [language, setLanguage] = useState<Language>('ru')
    const t = translations[language]

    const [activeTab, setActiveTab] = useState<string>(t.achievements_all)

    const [achievementResponse, setAchievementResponse] = useState<AchievementResponse | null>(null)
    const [userProfile, setUserProfile] = useState<UserProfile | null>(JSON.parse(localStorage.getItem('profile') || 'null'))

    const fetchAchievements = async () => {
        await AccomplishmentsService.getAchievements()
            .then((response) => {
                setAchievementResponse(response)
            })
            .catch((error) => {
                toast.error(
                    error && error.response && error.response.data && t[error.response.data as keyof typeof t]
                        ? t[error.response.data as keyof typeof t]
                        : t.error_unknown,
                    { className: 'notification-error' }
                )
            })
    }
    useEffect(() => {
        if (!achievementResponse) {
            fetchAchievements()
        }
    }, [achievementResponse])

    return (
        <>
            <Header
                selectedMode={RaceTypes.RANKED}
                selectedVehicle={null}
                profile={userProfile}
                setProfile={setUserProfile}
                title={t.achievements}
            />


            {achievementResponse &&
                <div className="achievements">
                    <div className='achievements-header' />

                    <div className="achievements-content">

                        <div className='achievements-progress-container-wrapper'>
                            <div className='achievements-progress-container'>
                                <div className='achievements-progress-container-content'>
                                    <p>{
                                        formatTextWithParams(t.achievements_earned_count,
                                            [
                                                achievementResponse.completedAchievements,
                                                achievementResponse.totalAchievements,
                                                achievementResponse.completionRate.toFixed(2)
                                            ])
                                    }</p>
                                    <div className="achievements-progress">
                                        <div className='achievements-progress-fill-wrapper'
                                            style={{ width: `${achievementResponse.completionRate}%` }}
                                        >
                                            <div
                                                className="achievements-progress-fill"
                                            ></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='achivements-content-wrapper'>
                            <div className='achievements-tabs'>
                                <Tabs
                                    activeTab={activeTab}
                                    setActiveTab={(tab) => setActiveTab(tab)}
                                    tabs={[
                                        { name: t.achievements_all },
                                        { name: t.achievements_earned },
                                    ]}
                                    tabsStyle={{
                                        width: '30%',
                                        height: '40px',
                                    }}
                                    tabStyle={{
                                        width: '50%'
                                    }}
                                />
                            </div>

                            <div className='achievements-list-wrapper'>
                                <div className='achievements-list'>
                                    {activeTab === t.achievements_all ? achievementResponse.achievements.map((achievement) => (
                                        <Achievement
                                            key={achievement.name}
                                            image={achievement.name}
                                            title={achievement.name}
                                            description={achievement.description}
                                            rarity={achievement.rate}
                                            progress={achievement.progressRate}
                                            dateTimeGot={achievement.completedAt}
                                        />
                                    )) : achievementResponse.achievements
                                        .filter((achievement) => achievement.completedAt !== null)
                                        .map((achievement) => (
                                            <Achievement
                                                key={achievement.name}
                                                image={achievement.name}
                                                title={achievement.name}
                                                description={achievement.description}
                                                rarity={achievement.rate}
                                                progress={achievement.progressRate}
                                                dateTimeGot={achievement.completedAt}
                                            />
                                        ))}
                                </div>
                            </div>
                        </div>
                    </div>
                    <Toaster
                        position="bottom-center"
                        toastOptions={{
                            duration: 2000,
                        }}
                    />
                </div>
            }</>
    )
}